module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-dynamic"
  }, [_c('div', {
    staticClass: "dyna-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textarea),
      expression: "textarea"
    }],
    ref: "textArea",
    staticClass: "text-area",
    attrs: {
      "placeholder": "点此输入工单动态..."
    },
    domProps: {
      "value": (_vm.textarea)
    },
    on: {
      "keyup": _vm.mention,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textarea = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mentionList.length),
      expression: "mentionList.length"
    }],
    staticClass: "mention-result"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _vm._l((_vm.mentionList), function(item, index) {
    return _c('li', {
      staticClass: "me-item",
      class: {
        actived: _vm.Mcurrent === index
      },
      on: {
        "click": function($event) {
          _vm.selectMention(item)
        },
        "mouseover": function($event) {
          _vm.changeCurrent(index)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.value))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "upload-wrap"
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImgBox),
      expression: "showImgBox"
    }],
    staticClass: "img-box",
    attrs: {
      "multiple": "",
      "limit": 9,
      "on-exceed": _vm.fileUploadLimitHook,
      "list-type": "picture-card",
      "action": _vm.uploadUlr,
      "data": _vm.uploadData,
      "accept": _vm.imgAccept,
      "on-success": _vm.handlePictureSuccess,
      "on-remove": _vm.handlePictureRemove,
      "on-error": _vm.handleError,
      "file-list": _vm.imgList,
      "before-upload": _vm.handleBeforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    on: {
      "click": _vm.set_upload_param
    }
  })]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFileBox),
      expression: "showFileBox"
    }],
    staticClass: "file-box",
    attrs: {
      "action": _vm.uploadUlr,
      "data": _vm.uploadData,
      "on-success": _vm.handleFileSuccess,
      "on-remove": _vm.handleFileRemove,
      "on-error": _vm.handleError,
      "before-upload": _vm.handleBeforeUpload,
      "file-list": _vm.fileList,
      "limit": 9,
      "on-exceed": _vm.fileUploadLimitHook
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.set_upload_param
    }
  }, [_vm._v("点击上传")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dyna-options"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.images.length,
      "hidden": !_vm.images.length
    }
  }, [_c('span', {
    on: {
      "click": _vm.toggleImgBox
    }
  }, [_c('span', {
    staticClass: "web-icon-img"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("图片")])])]), _vm._v(" "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.attachment.length,
      "hidden": !_vm.attachment.length
    }
  }, [_c('span', {
    on: {
      "click": _vm.toggleFileBox
    }
  }, [_c('span', {
    staticClass: "web-icon-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("附件")])])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("发 送")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("选择你要@的人")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-107a6db1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/work-order/add-dynamic.vue
// module id = 1215
// module chunks = 82